import { GeneralInfoState, Action } from './types'

export const updateGeneralInfo = ({
    contactName = '',
    isAcknowledged = false,
} = {}) => ({
    type: 'UPDATE_GENERAL_INFO',
    payload: {
        contactName,
        isAcknowledged,
    },
})

const generalInfoReducer: React.Reducer<GeneralInfoState, Action> = (
    state: GeneralInfoState,
    action: Action
) => {
    switch (action.type) {
        case 'UPDATE_GENERAL_INFO':
            return action.payload
        default:
            return state
    }
}

export default generalInfoReducer

// dispatch(updateGeneralInfo({ contactName: 'Jason', isAcknowledged: true }))
